import {postRequest} from "@pg-mono/request";
import {apiLink} from "@pg-mono/rp-api-routes";

import {TurnstileAction} from "../../app/constants/turnstile_actions";
import {createRpLeadPerformanceDebugTrace} from "../../app/performance_debug";
import {appendTurnstileToken} from "../../app/turnstile";
import type {JsonValues} from "../../form/translate/to_json_values";
import {IUserProfile} from "../../user/types/IUserProfile";

const emailSignUpApiLink = apiLink.user.register({});

export const emailSignUp = async (jsonData: JsonValues): Promise<IUserProfile> => {
    const trace = createRpLeadPerformanceDebugTrace("rp_email_sign_up", {
        action: TurnstileAction.REGISTRATION,
        endpoint: "user.register",
        hasMarketingEmail: Boolean(jsonData.marketing_email),
        hasMarketingSms: Boolean(jsonData.marketing_sms)
    });

    trace.mark("turnstile_append:start");
    const payload = await appendTurnstileToken(jsonData, TurnstileAction.REGISTRATION);
    trace.mark("turnstile_append:done", {hasTurnstileToken: "turnstile_token" in payload});

    try {
        trace.mark("api_request:start");
        const response = await postRequest({}, emailSignUpApiLink(null), payload);
        trace.end("api_request:success");

        return response;
    } catch (error) {
        trace.end("api_request:error");
        throw error;
    }
};
import {postRequest} from "@pg-mono/request";
import {apiLink} from "@pg-mono/rp-api-routes";

import {TurnstileAction} from "../../app/constants/turnstile_actions";
import {createRpLeadPerformanceDebugTrace} from "../../app/performance_debug";
import {appendTurnstileToken} from "../../app/turnstile";
import type {JsonValues} from "../../form/translate/to_json_values";
import {IUserProfile} from "../../user/types/IUserProfile";

const emailSignUpApiLink = apiLink.user.register({});

export const emailSignUp = async (jsonData: JsonValues): Promise<IUserProfile> => {
    const trace = createRpLeadPerformanceDebugTrace("rp_email_sign_up", {
        action: TurnstileAction.REGISTRATION,
        endpoint: "user.register",
        hasMarketingEmail: Boolean(jsonData.marketing_email),
        hasMarketingSms: Boolean(jsonData.marketing_sms)
    });

    trace.mark("turnstile_append:start");
    const payload = await appendTurnstileToken(jsonData, TurnstileAction.REGISTRATION);
    trace.mark("turnstile_append:done", {hasTurnstileToken: "turnstile_token" in payload});

    try {
        trace.mark("api_request:start");
        const response = await postRequest({}, emailSignUpApiLink(null), payload);
        trace.end("api_request:success");

        return response;
    } catch (error) {
        trace.end("api_request:error");
        throw error;
    }
};
